import { z } from "zod";

const OTHER_VEHICLE_TYPE_ID = "other";

export const subscriptionFormSchema = z.object({
  first_name: z.string().min(1, "First name is required"),
  last_name: z.string().min(1, "Last name is required"),
  vendor_id: z.string().min(1, "Please select a wash center"),
  vehicle_type_id: z.string().min(1, "Please select a vehicle type"),
  service_mapping_id: z.string().optional(),
  time_slot_index: z.string().min(1, "Please select a time slot"),
  vehicle_note: z.string().optional(),
}).refine((data) => {
  // If vehicle type is not "Other", service_mapping_id is required
  if (data.vehicle_type_id !== OTHER_VEHICLE_TYPE_ID && !data.service_mapping_id) {
    return false;
  }
  // If vehicle type is "Other", vehicle_note is required
  if (data.vehicle_type_id === OTHER_VEHICLE_TYPE_ID && !data.vehicle_note) {
    return false;
  }
  return true;
}, {
  message: "Please provide all required information",
  path: ["service_mapping_id"]
});

// Phone form schema
export const phoneSchema = z.object({
  phone: z
    .string()
    .min(10, 'Phone number must be 10 digits')
    .max(10, 'Phone number must be 10 digits')
    .regex(/^[6-9]\d{9}$/, 'Please enter a valid Indian phone number'),
});

// OTP form schema
export const otpSchema = z.object({
  pin: z
    .string()
    .min(6, 'OTP must be 6 digits')
    .max(6, 'OTP must be 6 digits')
    .regex(/^\d{6}$/, 'Please enter a valid OTP'),
});

export type PhoneFormValues = z.infer<typeof phoneSchema>;
export type OtpFormValues = z.infer<typeof otpSchema>;